module.exports = __webpack_public_path__ + "static/media/featured-profiles-form.968778c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/featured-profiles-form.jpg
// module id = 2104
// module chunks = 0